/* global dataLayer, pmtFBQ, fbq */
window.$ = window.jQuery = require('jquery');

module.exports = {
    "gTagHab": false,
    "fPixelHab": false,
    ini: function () {
        this.gTagHab = typeof dataLayer !== "undefined";
        this.fPixelHab = typeof fbq === "function";
    },
    click: function ($el) {
        if (!this.gTagHab) {
            return;
        }

        var $item = $el.closest("[data-nombre][data-id][data-categoria][data-precio]");
        var $parent = $el.closest("[data-list-name][data-list-id]");
        var listName = '';
        var listId = '';
        if ($parent.length > 0) {
            listName = $parent.attr("data-list-name");
            listId = $parent.attr("data-list-id");
        }
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "select_item",
            ecommerce: {
                items: [{
                    item_name: $item.attr("data-nombre"),
                    item_id: parseInt($item.attr("data-id")),
                    item_brand: $item.attr("data-marca"),
                    item_category: $item.attr("data-categoria"),
                    item_list_name: listName,
                    item_list_id: listId,
                    price: parseFloat($item.attr("data-precio"))
                }]
            }
        });
    },
    agregar: function (prodId, categoria, marca, precio, nombre, cantidad, listaNombre = '', listaId = '') {
        if (this.gTagHab) {
            // var pmts = {
            //     'send_to': pmtGTM.send_to,
            //     'ecomm_pagetype': pmtGTM.ecomm_pagetype,
            //     'ecomm_prodid': prodId,
            //     'ecomm_category': categoria,
            //     'ecomm_totalvalue': parseFloat(total)
            // };
            //
            // if (typeof pmtGTM.user_id !== "undefined") {
            //     pmts.user_id = pmtGTM.user_id;
            // }
            //
            // gtag('event', 'add_to_cart', pmts);

            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "add_to_cart",
                ecommerce: {
                    items: [{
                        item_name: nombre,
                        item_id: parseInt(prodId),
                        price: parseFloat(precio),
                        item_brand: marca,
                        item_category: categoria,
                        item_list_name: listaNombre,
                        item_list_id: listaId,
                        quantity: cantidad
                    }]
                }
            });
        }

        if (this.fPixelHab) {
            fbq('track', 'AddToCart', {
                content_ids: [prodId],
                content_type: 'product',
                content_category: categoria,
                value: parseFloat(precio),
                currency: 'EUR'
            });
        }

        if (typeof ttq !== "undefined") {
            ttq.track('AddToCart', {
                content_id: prodId,
                content_type: 'product',
                content_category: categoria,
                content_name: nombre,
                quantity: cantidad,
                price: parseFloat(precio),
                currency: 'EUR'
            })
        }

    },
    borrar: function (prodId, categoria, marca, precio, nombre, cantidad) {
        if (this.gTagHab) {
            // var pmts = {
            //     'send_to': pmtGTM.send_to,
            //     'ecomm_pagetype': pmtGTM.ecomm_pagetype,
            //     'ecomm_prodid': prodId,
            //     'ecomm_category': categoria,
            //     'ecomm_totalvalue': parseFloat(total)
            // };
            //
            // if (typeof pmtGTM.user_id !== "undefined") {
            //     pmts.user_id = pmtGTM.user_id;
            // }
            //
            // gtag('event', 'remove_from_cart', pmts);

            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "remove_from_cart",
                ecommerce: {
                    items: [{
                        item_name: nombre,
                        item_id: parseInt(prodId),
                        price: parseFloat(precio),
                        item_brand: marca,
                        item_category: categoria,
                        quantity: cantidad
                    }]
                }
            });
        }
    },
    vaciar: function (items) {
        if (this.gTagHab) {
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "remove_from_cart",
                ecommerce: {
                    items: items
                }
            });
        }
    },
    actualizar: function (itemsAgregados, itemsBorrados) {
        if (this.gTagHab) {
            if (itemsAgregados.length > 0) {
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: "add_to_cart",
                    ecommerce: {
                        items: itemsAgregados
                    }
                });
            }

            if (itemsBorrados.length > 0) {
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: "remove_from_cart",
                    ecommerce: {
                        items: itemsBorrados
                    }
                });
            }
        }
    }
}